import { useEffect, useRef } from "react";
import { useTracker } from "@ferrivia/auth-web";
import { displayMode } from "./installability";

/**
 * On iOS there is no appinstalled event and no way to observe an A2HS, so a
 * session launched in "standalone" is the only evidence an install happened.
 * Fires once per app boot, independent of whether the banner ever rendered.
 */
export function AppLaunchTracker() {
  const tracker = useTracker();
  // A ref, not a dep: tracker's identity can change (e.g. locale switch) but
  // this must still fire exactly once per boot, not once per identity change.
  const trackerRef = useRef(tracker);
  trackerRef.current = tracker;

  useEffect(() => {
    trackerRef.current.track("app.launched", { display_mode: displayMode() });
  }, []);

  return null;
}
